import { fillFlatpickrInput, flatpickrAltInput, isFlatpickrInput } from "./date_utils";

export const isSelect2Input = (input) => input.dataset.controller === "select2";

export const selectedOptionFor = (selectInput) => selectInput.options[selectInput.selectedIndex];

export const selectOptionFor = (selectInput, optionValue) => $(selectInput).val(optionValue).trigger("change");

export const select2Element = (input) => $(input).data("select2");

export const select2ContainerFor = (selectInput) => selectInput.nextElementSibling;

export const disableSelect2Option = (selectInput, optionValue) =>
  toggleSelect2OptionAbility(selectInput, optionValue, true);

export const enableSelect2Option = (selectInput, optionValue) =>
  toggleSelect2OptionAbility(selectInput, optionValue, false);

export const hasAvailableSelect2Option = (selectInput) =>
  $(selectInput).find('option:not([value=""]):not(:disabled)').length > 0;

const toggleSelect2OptionAbility = (selectInput, optionValue, disabled) =>
  $(selectInput).find(`option[value="${optionValue}"]`).prop("disabled", disabled).trigger("change.select2");

export const isCheckbox = (input) => input.type === "checkbox";

export const isEscapeKey = (keyCode) => keyCode === 27;

export const isEnterKey = (keyCode) => keyCode === 13;

export const inputToValidate = (input) => (isFlatpickrInput(input) ? flatpickrAltInput(input) : input);

export const selectedCheckboxesValues = (inputName) => {
  const selectedCheckboxes = document.querySelectorAll(`input[name='${inputName}']:checked`);
  return Array.from(selectedCheckboxes).map((el) => el.value);
};

export const fillInput = (input, value) => {
  if (isFlatpickrInput(input)) {
    fillFlatpickrInput(input, value);
  } else {
    input.value = value || "";
  }
};

export const numberOfItems = (ids) => {
  if (ids.value === "") {
    return 0;
  } else {
    return ids.value.split(",").length;
  }
};

export const inputValueById = (id) => {
  return inputValueBySelector(`#${id}`);
};

export const inputValueBySelector = (selector) => {
  let value;
  const input = document.querySelector(selector);
  if (input) {
    if (isSelect2Input(input)) {
      value = $(input).val();
    } else {
      value = input.value;
    }
  }
  return value;
};

export const emptySelect = (select) => {
  select.length = 0;
};

export const addNewOptionToSelect = (select, option) => {
  select.add(new Option(option.text, option.value));
};

export const sortSelectAlphabetically = (select) => {
  return Array.from(select.options)
    .map((option) => ({ text: option.innerText, value: option.value }))
    .sort((a, b) => {
      if (a.text < b.text) return -1;
      if (a.text > b.text) return 1;
      return 0;
    });
};

export const fillFromSortedSelect = (select) => {
  const sortedSelect = sortSelectAlphabetically(select);

  emptySelect(select);
  sortedSelect.forEach((option) => {
    addNewOptionToSelect(select, option);
  });
};

export const elementsNamesFrom = (elements) => {
  return Array.from(elements).map((element) => element.name);
};

export const focusField = (field) => {
  field.focus();
};

export const resetParsleyFor = (form) => {
  $(form).parsley().reset();
};

export const setParsleyMaxDate = (input, date) => {
  input.dataset.parsleyDlte = date;
};
